const productsData = [
    {
        id: 1,
        brand: 'elate cosmetics',
        name: 'Intrepid Pressed Natural Eyeshadow Trio',
        price: '61.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/10/02075424/elate-cosmetics-intrepid-pressed-natural-eyeshadow-trio-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-intrepid-pressed-natural-eyeshadow-trio/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics/',
        description: 'Elevate any eye-look with the Intrepid Pressed Natural Eyeshadow Trio by Elate Cosmetics. Natural mineral pigments create rich colors and organic jojoba oils and bamboo extracts make for a silky application that stays on all day. Three unique colors are compatible for easy eyeshadow application, and include a light, shimmery shadow, a mauve colored shadow, and a glittery gold. Plus, it comes packaged in a reusable and refillable natural bamboo case that looks beautiful in your bathroom!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 2,
        brand: 'elate cosmetics',
        name: 'Gold Shimmer Water Resistant Liquid Eyelinger',
        price: '24.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/10/02075412/elate-cosmetics-gold-shimmer-water-resistant-liquid-eyeliner-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-gold-shimmer-water-resistant-liquid-eyeliner/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics/',
        description: 'Whether you are going for a simple and polished look or one that is a little more bold... Clean ingredients and a gentle, water-resistant formula works for even the most sensitive eyes, and the silky application gives a smooth and precise appearance.',
        product_type: 'eyeliner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 3,
        brand: 'elate cosmetics',
        name: 'Bliss Universal Natural Makeup Creme',
        price: '28.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145037/elate-cosmetics-Bliss-Universal-Natural-Makeup-Creme-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-bliss-universal-natural-makeup-creme/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Start blushing! Get an instant healthy glow with the Universal Creme by Elate Cosmetics. Skin-beautifying ingredients like jojoba oil, zinc, evening primrose, and sea buckthorne nourish and hydrate while the creme formula allows for smooth and buildable finish. Bliss is a warm coral, great for creating a subtlety sunkissed look.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 4,
        brand: 'elate cosmetics',
        name: 'Natural Black Mascara',
        price: '27.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145225/elate-cosmetics-Natural-Black-Mascara-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-natural-black-mascara/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "We all know what it is like to apply mascara in the morning only to have smudged, raccoon eyes by mid-day. But wait, there is a solution that does not involve harsh chemicals or fillers! The Essential Mascara by Elate Cosmetics provides a lengthening and plumping formula that is both water and sweat resistant. Plus, it's safe for even the most sensitive eyes. Start at the base and comb out towards the ends, adding more coats as needed. Brush through with a clean spoolie for a more natural look.",
        product_type: 'mascara',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 5,
        brand: 'elate cosmetics',
        name: 'Rosebud Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145709/elate-cosmetics-Rosebud-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-rosebud-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 6,
        brand: 'elate cosmetics',
        name: 'Plenty Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145312/elate-cosmetics-Plenty-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-plenty-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "The hunt for the perfect lipcolor is over! With the Crème Lipstick from Elate Cosmetics you don't have to choose between rich hues and high-quality ingredients. Organic mango and shea butters soothe and condition lips while adding a subtle shine. A touch of vanilla essential oil leaves behind a soft, uplifting scent that's sure to keep you smiling all day long. Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.",
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 7,
        brand: 'elate cosmetics',
        name: 'Sweet Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173025/22-elate-create-pressed-eyecolour-sweet-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-sweet-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Sweet Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 8,
        brand: 'elate cosmetics',
        name: 'Earthen Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173006/17-elate-create-pressed-eyecolour-earthen-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-earthen-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Earthen Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 9,
        brand: 'elate cosmetics',
        name: 'Stone Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173021/21-elate-create-pressed-eyecolour-stone-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-stone-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Stone Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 10,
        brand: 'elate cosmetics',
        name: 'Gifted Pressed Eyeshadow Trio',
        price: '61.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145124/elate-cosmetics-Gifted-Pressed-Natural-Eyeshadow-Trio-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-gifted-pressed-natural-eyeshadow-trio/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Elevate any eye-look with the Pressed Natural Eyeshadow Trio by Elate Cosmetics. Natural mineral pigments create rich colors and organic jojoba oils and bamboo extracts make for a silky application that stays on all day. Gifted is a shimmery, golden bronze.',
        product_type: 'eyeshadow',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 11,
        brand: 'elate cosmetics',
        name: 'Refresh Organic Liquid Foundation',
        price: '31.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145505/elate-cosmetics-Refresh-Liquid-Organic-Foundation-2.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-refresh-liquid-organic-foundation/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Is your foundation making your skin breakout? Conventional foundations can contain ingredients that irritate skin and clog your pores, but the Refresh Liquid Foundation from Elate Cosmetics is different. This organic foundation is made from natural, fair-trade ingredients like soothing sunflower oil and moisturizing hyaluronic acid. Plus it's vegan, cruelty-free and hypoallergenic for all skin types – including sensitive skin. This liquid foundation features a smooth, lightweight finish and offers all-day hydration, so you continue to glow even after you take it off! Apply this foundation with your fingers or a sponge for a lighter look, or use a foundation brush for slightly more coverage.",
        product_type: 'foundation',
        cruelty_free: 0,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 12,
        brand: 'elate cosmetics',
        name: 'Love Universal Natural Makeup Créme',
        price: '28.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145153/elate-cosmetics-Love-Universal-Natural-Makeup-Creme-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-love-universal-natural-makeup-creme/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Start blushing! Get an instant healthy glow with the Universal Creme by Elate Cosmetics. Skin-beautifying ingredients like jojoba oil, zinc, evening primrose, and sea buckthorne nourish and hydrate while the creme formula allows for smooth and buildable finish. Love is a bright, youthful pink. Tip: Pop a little bit on your lips for a moisturizing color boost! For your cheeks: Apply directly on or under your cheek bones. Blend with your fingertips, or use a brush for creating a more diffused color. For your lips: Smooth over your lips like a balm, or use a lip brush for a more precise application.',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 13,
        brand: 'elate cosmetics',
        name: 'Ethereal Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173010/18-elate-create-pressed-eyecolour-ethereal-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-ethereal-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Ethereal Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 14,
        brand: 'elate cosmetics',
        name: 'Coy Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/11/08181204/elate-cosmetics-coy-lip-pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-coy-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Coy Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 15,
        brand: 'elate cosmetics',
        name: 'Natural Brown Mascara',
        price: '27.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173032/24-elate-essential-mascara-brown-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-natural-brown-mascara/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "We all know what it's like to apply mascara in the morning only to have smudged, raccoon eyes by mid-day. But wait, there's a solution that doesn't involve harsh chemicals or fillers! The Natural Brown Mascara by Elate Cosmetics provides a lengthening and plumping formula that is both water and sweat resistant. Plus, it's safe for even the most sensitive eyes. Start at the base and comb out towards the ends, adding more coats as needed. Brush through with a clean spoolie for a more natural look.",
        product_type: 'mascara',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 16,
        brand: 'elate cosmetics',
        name: 'Organic Pressed Powder Foundation',
        price: '41.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145426/elate-cosmetics-Pressed-Powder-Organic-Foundation-ivory-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-pressed-powder-organic-foundation/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Looking for a flawless finish but worried about how makeup may affect your skin? The Organic Pressed Powder Foundation from Elate Cosmetics not only masks redness and evens out skintone, but also promotes a healthy and clear complexion. Key ingredients like bamboo extracts soothe irritation while argan and coconut oils hydrate and enhance your natural glow. This elegant bamboo compact is refillable and once finished, a new foundation palette arrives in plantable seed paper! To build full coverage, use a powder foundation brush and swirl the minerals onto clean and moisturized skin. For medium coverage, use a sponge. Use a loose powder brush for light coverage and for setting creme products.',
        product_type: 'foundation',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 17,
        brand: 'elate cosmetics',
        name: 'Brazen Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145049/elate-cosmetics-Brazen-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-brazen-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "The hunt for the perfect lipcolor is over! With the Crème Lipstick from Elate Cosmetics you don't have to choose between rich hues and high-quality ingredients. Organic mango and shea butters soothe and condition lips while adding a subtle shine. A touch of vanilla essential oil leaves behind a soft, uplifting scent that's sure to keep you smiling all day long. Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.",
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 18,
        brand: 'elate cosmetics',
        name: 'Onyx Eyeliner Pencil',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191635/Elate-Onyx-Eyeliner-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-onyx-eyeliner-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Create flawless eye makeup looks with the Onyx Eyeliner Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this eyeliner pencil has smooth application and long-wearing hold that allows you to effortlessly apply onto your eyelids or brows. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. No matter what look you're going for, this low-waste eyeliner makes it easy!",
        product_type: 'eyeliner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 19,
        brand: 'elate cosmetics',
        name: 'Prim Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/11/08181324/elate-cosmetics-prim-lip-pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-prim-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Prim Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 20,
        brand: 'elate cosmetics',
        name: 'Revere Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/11/08181350/elate-cosmetics-revere-lip-pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-revere-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Rever Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 21,
        brand: 'elate cosmetics',
        name: 'Wonder Universal Natural Makeup Créme',
        price: '28.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145730/elate-cosmetics-Wonder-Universal-Natural-Makeup-Creme-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-wonder-universal-natural-makeup-creme/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Love how you look in candle light? This highlighter is for you! Get an instant healthy glow with the Universal Creme by Elate Cosmetics. Skin-beautifying ingredients like jojoba oil, zinc, evening primrose, and sea buckthorne nourish and hydrate while the creme formula allows for a smooth and buildable finish. Wonder is a golden peach highlight, perfect for cheekbones, eyelids, and cupids bow. Adding this atop any blush with give a lit from within look! Tip: Pop a little bit on your lips for a moisturizing shine! For your cheeks: Apply directly on or under your cheek bones. Blend with your fingertips, or use a brush for creating a more diffused color. For your lips: Smooth over your lips like a balm, or use a lip brush for a more precise application.',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 22,
        brand: 'elate cosmetics',
        name: 'Brown Water Resistant Liquid Eyeliner',
        price: '24.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145103/elate-cosmetics-Brown-Water-Resistant-Liquid-Eyeliner-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-brown-water-resistant-liquid-eyeliner/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Whether your going for a simple and polished look or one that's a little more bold, Elate Cosmetic's Liquid EyeLine will get you there. Clean ingredients and a gentle, water-resistant formula works for even the most sensitive eyes, and the silky application gives a smooth and precise appearance. Resolute is a matte dark brown that's perfect for that natural, everyday eyelook. The special artist tip brush allows for the easiest application. Simply rest the brush on your lashes and use short strokes to create your line.",
        product_type: 'eyeliner',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 23,
        brand: 'elate cosmetics',
        name: 'Black Water Resistant Liquid Eyeliner',
        price: '24.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145024/elate-cosmetics-Black-Water-Resistant-Liquid-Eyeliner-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-black-water-resistant-liquid-eyeliner/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Whether your going for a simple and polished look or one that's a little more bold, Elate Cosmetic's Liquid EyeLine will get you there. Clean ingredients and a gentle, water-resistant formula works for even the most sensitive eyes, and the silky application gives a smooth and precise appearance. Origin is a matte black that's great for everyday, but versatile enough for a sultry nighttime look, too. The special artist tip brush allows for the easiest application. Simply rest the brush on your lashes and use short strokes to create your line.",
        product_type: 'eyeliner',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 24,
        brand: 'elate cosmetics',
        name: 'Indulge Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191630/Elate-Indulge-Lip-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-indulge-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Indulge Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 25,
        brand: 'elate cosmetics',
        name: 'Serene Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191641/Elate-Serene-Lip-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-serene-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Serene Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 26,
        brand: 'elate cosmetics',
        name: 'Darling Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/11/08181235/elate-cosmetics-darling-lip-pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-darling-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Darling Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 27,
        brand: 'elate cosmetics',
        name: 'Elevate Vibrant Natural Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/10/02075402/elate-cosmetics-elevate-vibrant-natural-lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-elevate-vibrant-natural-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "The hunt for the perfect lipcolor is over! With the Elevate Vibrant Natural Lipstick from Elate Cosmetics you don't have to choose between rich hues and high-quality ingredients. Ingredients like Vitamin E and bayberry fruit wax keep your smile supple and smooth while leaving behind vibrant color. A touch of vanilla essential oil leaves behind a soft, uplifting scent that's sure to keep you smiling all day long. Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.",
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 28,
        brand: 'elate cosmetics',
        name: 'Apropos Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27144909/elate-cosmetics-Apropos-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-apropos-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "The hunt for the perfect lipcolor is over! With the Crème Lipstick from Elate Cosmetics you don't have to choose between rich hues and high-quality ingredients. Organic mango and shea butters soothe and condition lips while adding a subtle shine. A touch of vanilla essential oil leaves behind a soft, uplifting scent that's sure to keep you smiling all day long. Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.",
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 29,
        brand: 'elate cosmetics',
        name: 'Revealer Organic Concealer Créme',
        price: '25.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145639/elate-cosmetics-Revealer-Organic-Concealer-Creme-porcelain-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-revealer-organic-concealer-creme/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Makeup that doubles as skincare? Believe it or not, it is possible! The Crème Revealer Concealer by Elate Cosmetics contains nature's best skin-healing ingredients like Evening Primrose Oil, Bamboo Stem Extract, and Borage Oil. Packaged in a beautiful and refillable bamboo compact, this concealer is sure to enhance your daily routine. When it's time for a refill, your new insert will arrive packed in plantable seed paper! Apply with a small brush or little finger to camouflage under-eye circles, blemishes, scars or pigmentation. Blend, and set with powder for that perfect finish.",
        product_type: 'primer_concealer',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 30,
        brand: 'elate cosmetics',
        name: 'Uplift Organic Creme Foundation',
        price: '31.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/10/02075535/elate-cosmetics-uplift-creme-organic-foundation-UW4-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-uplift-creme-organic-foundation/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Uplift your skin with the Uplift Creme Organic Foundation from Elate Cosmetics! Made from natural and ethical ingredients like jojoba oil for moisture, bamboo stem extract for its anti-irritation properties, and seabuckthorn for revitalization, this cream foundation has buildable coverage so you can have a light finish, or a more full coverage. It comes packaged in a beautiful glass and bamboo case, and has a whipped texture that is easy to apply. Just add additional layers for a more opaque look!',
        product_type: 'foundation',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 31,
        brand: 'elate cosmetics',
        name: 'Natural Brow Balm',
        price: '27.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145305/elate-cosmetics-Natural-Eyebrow-Powder-Balm-suede-first-time-order-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-natural-eyebrow-powder-balm/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Is it possible to care about the planet AND have eyebrows that are on fleek? Yes, it is! Elate Cosmetic's Natural Eyebrow Balm gives a natural tint to brows and features a waxy texture that keeps unruly hairs in place. Plus it's vegan, non-toxic, and cruelty-free, so there's nothing to raise an eyebrow at here! With an angled brush, use small upward strokes from the base of your brows out to your arch. Use small downward strokes from your arch to the tip of your brow.",
        product_type: 'eyebrow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 32,
        brand: 'elate cosmetics',
        name: 'Rise Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173013/19-elate-create-pressed-eyecolour-rise-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-rise-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Rise Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 33,
        brand: 'elate cosmetics',
        name: 'Ardent Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191614/Elate-Ardent-Lip-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-ardent-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Ardent Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 34,
        brand: 'elate cosmetics',
        name: 'Enigma Lip Pencil',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191619/Elate-Enigma-Lip-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-enigma-lip-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Add the finishing touches to your makeup look with the Enigma Lip Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this lip liner pencil has smooth application and long-wearing hold that allows you to effortlessly apply to the lips. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. Perfect on its own, or paired with your favorite lipstick, this lip liner is a makeup bag essential!',
        product_type: 'lip_liner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 35,
        brand: 'elate cosmetics',
        name: 'Aerial Pressed Natural Eyeshadow Trio',
        price: '61.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27144851/elate-cosmetics-Aerial-Pressed-Natural-Eyeshadow-Trio-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-aerial-pressed-natural-eyeshadow-trio/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Elevate any eye-look with the Pressed Natural Eyeshadow Trio by Elate Cosmetics. Natural mineral pigments create rich colors and organic jojoba oils and bamboo extracts make for a silky application that stays on all day. Aerial is a celestial pale pink with subtle shimmer.',
        product_type: 'eyeshadow',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 36,
        brand: 'elate cosmetics',
        name: 'Warrior Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145719/elate-cosmetics-Warrior-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-warrior-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.',
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 37,
        brand: 'elate cosmetics',
        name: 'Plush Créme Organic Lipstick',
        price: '21.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/06/27145320/elate-cosmetics-Plush-Cre%CC%80me-Organic-Lipstick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-plush-creme-organic-lipstick/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "The hunt for the perfect lipcolor is over! With the Crème Lipstick from Elate Cosmetics you don't have to choose between rich hues and high-quality ingredients. Organic mango and shea butters soothe and condition lips while adding a subtle shine. A touch of vanilla essential oil leaves behind a soft, uplifting scent that's sure to keep you smiling all day long. Apply directly from the tube (or with a lip brush for more precision) Blot, and reapply for more color, or blot again for a wash of tone.",
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 38,
        brand: 'elate cosmetics',
        name: 'Surge Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173017/20-elate-create-pressed-eyecolour-surge-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-surge-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Surge Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 39,
        brand: 'elate cosmetics',
        name: 'Union Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173028/23-elate-create-pressed-eyecolour-union-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-union-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Union Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 40,
        brand: 'elate cosmetics',
        name: 'Hearth Eyeliner Pencil',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/09/24191625/Elate-Hearth-Eyeliner-Pencil-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-hearth-eyeliner-pencil/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: "Create flawless eye makeup looks with the Hearth Eyeliner Pencil from Elate Cosmetics! Made from COSMOS Certified organic ingredients, this eyeliner pencil has smooth application and long-wearing hold that allows you to effortlessly apply onto your eyelids or brows. The pencil is made with California cedarwood that is PEFC certified and guarantees sustainable forest management, with a corn bioplastic lid. No matter what look you're going for, this low-waste eyeliner makes it easy!",
        product_type: 'eyeliner',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 41,
        brand: 'elate cosmetics',
        name: 'Beloved Pressed Eye Color',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/02/05173002/16-elate-create-pressed-eyecolour-beloved-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-beloved-pressed-eye-color/',
        website_link: 'https://earthhero.com/product-category/elate-cosmetics',
        description: 'Create beautiful eye makeup looks with help from the Beloved Pressed Eye Color from Elate Cosmetics! Made from vegan and cruelty free ingredients, this pressed eye shadow soothes and nourishes your eyelids, while containing vivid, bright pigment for a vibrant and long lasting look. It comes packaged plastic-free in a seed paper envelope in a recyclable aluminum pan that is meant to be stored and organized in a reusable palette or compact (the Elate Cosmetics brand one is an awesome option, but it is compatible with other palettes as well!) From eyeliner, to eyeshadow, or any way you want to get creative with your makeup, this pressed powder does it all!',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 43,
        brand: 'river organics',
        name: 'Zero Waste Concealer',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/07/10093207/00-Concealer-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-zero-waste-concealer/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Even skin tone, combat redness, and conceal blemishes with the Zero Waste Concealer by River Organics! Made with cruelty-free, vegan, and organic ingredients, this creamy cover-up nourishes and soothes skin, leaving a hydrated, flawless finish. You might even forget you're wearing makeup! Plus, the packaging is entirely plastic-free!",
        product_type: 'primer_concealer',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 44,
        brand: 'fat and the moon',
        name: 'Black Mineral Eye Coal',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114744/fat-and-the-moon-Black-Mineral-Eye-Coal-Eyeliner-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-black-mineral-eye-coal-eyeliner/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: 'Create that smoky eye with ease thanks to the Black Mineral Eye Coal from Fat and the Moon! Made from non-toxic and organic ingredients like sunflower oil, beeswax, and kaolin clay, this eye coal can be used as an eye shadow or eyeliner. The sunflower oil sinks into your skin and helps keep the pigment in place without budging. To use, grab a makeup brush and apply, or use a clean finger for eyeliner on the waterline.',
        product_type: 'eyeliner',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 1
      },
    {
        id: 45,
        brand: 'fat and the moon',
        name: 'Beam Highlighter Cream',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114501/Fat-and-the-moon-Beam-Highlighter-Cream-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-beam-highlighter-cream/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Add some shimmer to your life with the Beam Highlighter Cream from Fat and the Moon! Made from non-toxic and organic ingredients, this natural makeup highlighter cream features a silver-toned shimmer and can be applied any place you need some glow. It contains non-toxic sunflower oil, beeswax, and mica that won't clog pores or damage your skin when applied. It's ethically and safely wildcrafted and is perfect for all skin types.",
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 1
      },
    {
        id: 47,
        brand: 'elate cosmetics',
        name: 'Prep Natural Makeup Primer',
        price: '41.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2019/10/02075440/elate-cosmetics-prep-natural-makeup-primer.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/elate-cosmetics-prep-natural-makeup-primer/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Don't put on any makeup without the help of the Prep Natural Makeup Primer from Elate Cosmetics first! Made from natural and ethical ingredients, this smoothing makeup primer is perfect as the last step of your skin care routine – and the first step to any makeup look. Floral hydrate complex pairs with nourishing hyaluronic acid to plump and firm skin while smoothing and hydrating as well. It helps makeup stay on better, for longer, and adds a silky glowing finish. To use, apply 3-4 drops and press into skin before applying makeup! Can also be used as an overnight hydration treatment.",
        product_type: 'primer_concealer',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 48,
        brand: 'river organics',
        name: 'Terra Cotta Blush Stick',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/05/14150345/river-organics-vegan-blush-stick-terra-cotta-1-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-terra-cotta-blush-stick/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "For a fresh and sunkissed glow, look no further than the Terra Cotta Blush Stick from River Organics! Made with cruelty free, vegan, and organic ingredients, this blush contains beautifying plant oils to both hydrate and plump skin. A warm tan hue offers a gentle flush for a healthy, youthful look and is also great for contouring. Plus, it's packaged in compostable plastic free packaging!",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 49,
        brand: 'fat and the moon',
        name: 'Earth Mineral Eye Coal',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114520/Fat-and-the-moon-Earth-Mineral-Eye-Coal-Eyeliner-NEW-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-earth-mineral-eye-coal-eyeliner/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: 'Create that smoky eye with ease thanks to the Earth Mineral Eye Coal from Fat and the Moon! Made from non-toxic and organic ingredients like sunflower oil, beeswax, and kaolin clay, this eye coal can be used as a eye shadow or eye liner. The sunflower oil sinks into your skin letting the pigment stay in place without budging. To use, grab a makeup brush and apply, or use a clean finger for eyeliner on the waterline.',
        product_type: 'eyeliner',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 50,
        brand: 'river organics',
        name: 'Pinch Blush Stick',
        price: '17.50',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/06/10144928/River-Organics-Pinch-Blush-Stick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-pinch-blush-stick/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Add a natural pop of color to your cheeks with the Pinch Blush Stick from River Organics! Made with cruelty-free, vegan, and organic ingredients, this blush contains beautifying pomegranate seed and red raspberry oil to both hydrate and plump skin. A light tint offers a gentle flush for a healthy, youthful look. Plus, it's packaged in compostable plastic-free packaging!",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 52,
        brand: 'fat and the moon',
        name: 'Ruby Red Tinted Lip Balm',
        price: '13.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114537/fatm-ruby-red-tinted-balm-1-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-ruby-red-tinted-lip-balm/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: 'Bring a natural flush to your lip look with the Ruby Red Tinted Lip Balm from Fat and the Moon! Made from natural and organic ingredients like beetroot powder, sunflower oil, and beeswax, this lip stain has a beautiful ruby red color and hydrates the lips as you wear it. Essential oils of clove and orange are added for a light scent, while beeswax protects the lips from damage. To use, simply dab a finger in the plastic-free tin and apply to the lips!',
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 53,
        brand: 'river organics',
        name: 'Peachy Blush Stick',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/05/14150336/river-organics-vegan-blush-stick-peachy-1-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-peachy-blush-stick/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Add a pop of color to your cheeks with the Peachy Blush Stick from River Organics! Made with cruelty free, vegan, and organic ingredients, this gorgeous cream blush contains beautifying plant oils to both hydrate and plump skin. The light and soft hue offers a gentle flush for a healthy, youthful look. Plus, it's packaged in a plastic-free and compostable tube.",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 54,
        brand: 'fat and the moon',
        name: 'Dusk Beeswax Lip Stain',
        price: '23.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114509/Fat-and-the-moon-Dusk-Beeswax-Lip-Stain-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-dusk-beeswax-lip-stain/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Calling all lipstick lovers! The Dusk Beeswax Lip Stain from Fat and the Moon is your new go-to for plastic-free lip care. Made from organic and cosmetic grade ingredients like sunflower oil, beeswax, and mineral pigments, this lipstick style lip stain features a dusky purple-ish red color and plastic-free tin. Added vitamin E keeps the lips hydrated and healthy, with a bold color you'll love. It has a matte finish, and can also be used on the cheeks for a matching blush.",
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 55,
        brand: 'fat and the moon',
        name: 'Lit Highlighter Cream',
        price: '17.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114800/1-EH-FATM-Lit-highlighter-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-lit-highlighter-cream/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Even on a cloudy day, you can find sunshine if you look for it. Luckily, this Lit Highlighter Cream from Fat and the Moon is bursting with sunshine! The lightweight mineral shimmer has warm tones of pinks, beige, and copper that will bring out your inner radiance. Get that subtle pop you've been craving with this plastic-free, handmade highlighter cream!",
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 56,
        brand: 'river organics',
        name: 'Zero Waste Brow Wax',
        price: '16.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/07/10093517/River-Organics-Ash-Concealer-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-zero-waste-brow-wax/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Tint and tame unruly brows with the Zero Waste Brow Wax by River Organics! Made with cruelty-free, vegan, and organic ingredients, this creamy wax keeps brows in place all day and nourishes skin with plant oils of jojoba, apricot, and shea. Plus, it's packaged in compostable plastic-free packaging!",
        product_type: 'eyebrow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 57,
        brand: 'river organics',
        name: 'Bloom Blush Stick',
        price: '17.50',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/06/10144906/River-Organics-Bloom-Blush-Stick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-bloom-blush-stick/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Add some natural color to your cheeks with the Bloom Blush Stick from River Organics! Made with cruelty-free, vegan, and organic ingredients, this blush contains beautifying pomegranate seed and red raspberry oil to both hydrate and plump skin. A light tint offers a gentle flush for a healthy, youthful look. Plus, it's packaged in compostable plastic-free packaging!",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 58,
        brand: 'fat and the moon',
        name: 'Beetroot Check + Lip Stain',
        price: '15.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/04/16114526/fatm-lip-and-cheek-stain-1-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/fat-and-the-moon-beetroot-cheek-lip-stain/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Bring a natural flush to your makeup look with the Beetroot Cheek + Lip Stain from Fat and the Moon! Made from natural and organic ingredients like beetroot powder, sunflower oil and beeswax, this lip and cheek makeup stain won't clog pores or damage skin, and provides a beautiful red wine color wherever you apply it. It has mild antibacterial, astringent, and anti-inflammatory properties to aid in skin quality, and looks beautiful on all skin types. Simply dab your finger into the plastic free tin and apply wherever for a pop of color!",
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 59,
        brand: 'all good',
        name: 'SPF 15 Lip and Cheek Tint',
        price: '19.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/05/19152011/all-good-spf-lip-and-cheek-tint-jam-1.jpeg',
        product_link: 'https://earthhero.com/products/beauty-care/all-good-spf-15-lip-and-cheek-tint/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: 'Skincare and makeup combine in the SPF 15 Lip and Cheek Tint from All Good! Made in the USA from organic, vegan, and cruelty-free ingredients, this SPF15 makeup tint has a creamy formula and added nourishing botanicals like shea butter and avocado oil, as well as healing calendula. It keeps the skin hydrated, glowy, and protected from the sun! Simply apply it to the lips, eyes, cheeks, or anywhere you want to add some color.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 60,
        brand: 'river organics',
        name: 'Rose Quartz Highlighting Makeup Stick',
        price: '16.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2020/06/10144952/River-Organics-Rose-Quartz-Highlighting-Makeup-Stick-1.jpg',
        product_link: 'https://earthhero.com/products/beauty-care/river-organics-rose-quartz-highlighting-makeup-stick/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: "Enhance skin's luminosity with the Rose Quartz Highlighting Makeup Stick from River Organics! Made with cruelty-free, vegan, and organic ingredients, this makeup stick gives your face a fresh, dewy look while nourishing and healing the skin. It contains hydrating shea butter, anti-inflammatory grapeseed, and rosehip oils, and comes in plastic-free packaging, too!",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 61,
        brand: 'all good',
        name: 'Shimmer Lip and Cheek Tint',
        price: '19.99',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://d13wriz42ny3t5.cloudfront.net/production/2021/05/19151948/all-good-lip-and-cheek-tint-shimmer-1-1.jpeg',
        product_link: 'https://earthhero.com/products/beauty-care/all-good-shimmer-lip-and-cheek-tint/',
        website_link: 'https://earthhero.com/product-category/beauty-care/makeup/',
        description: 'Skincare and makeup combine in the Shimmer Lip and Cheek Tint from All Good! Made in the USA from organic, vegan, and cruelty-free ingredients, this shimmery makeup tint has a creamy formula and added nourishing botanicals like shea butter and avocado oil, as well as healing calendula. It keeps the skin hydrated and glowy for all-day wear! Simply apply it to the lips, eyes, cheeks, or anywhere you want to add some shimmer.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 62,
        brand: 'odylique',
        name: 'Organic Mineral Lipstick #20 - Blackberry Smoothie',
        price: '34.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/214/404/organic-lipstick-blackberry__46241.1593088192.jpg?c=1',
        product_link: 'https://odylique.com/blackberry-smoothie.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: 'Blackberry Smoothie is a deliciously deep mauve perfect for day or evening wear. \n' +
          '\n' +
          'We hope you’ll love the creamy, nourishing texture of our lipsticks just as much as we do! \n' +
          '\n' +
          'They are bursting with organic plant oils and butters including jojoba and Fairtrade shea to provide a moisturising vitamin-boost to your lips.',
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 64,
        brand: 'odylique',
        name: 'Organic Mineral Lipstick #19 - Peach Melba',
        price: '34.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/213/486/organic-peach-lipstick__62822.1593079665.png?c=1',
        product_link: 'https://odylique.com/peach-melba.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: "Peach Melba is a matte peachy pink shade that gives a beautiful your 'lip but better'colour.\n" +
          '\n' +
          'We hope you’ll love the creamy, nourishing texture of our lipsticks just as much as we do! \n' +
          '\n' +
          'They are bursting with organic plant oils and butters including jojoba and Fairtrade shea to provide a moisturising vitamin-boost to your lips.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 65,
        brand: 'odylique',
        name: 'Organic Mineral Lipstick #18 - Fig Fondant',
        price: '34.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/212/485/organic-lipstick-fig__68200.1593079643.png?c=1',
        product_link: 'https://odylique.com/organic-lipstick-fig-fondant.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: 'A warm burnished pink, like the juicy flesh of a ripe fig, this colour is gorgeous with gloss for day or on its own for a richer, night-time glow.\n' +
          '\n' +
          'We hope you’ll love the creamy, nourishing texture of our lipsticks just as much as we do! \n' +
          'They are bursting with organic plant oils and butters including jojoba and Fairtrade shea to provide a moisturising vitamin-boost to your lips.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 66,
        brand: 'odylique',
        name: 'Organic Mineral Lipstick #17 - Apricot Sorbet',
        price: '34.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/211/487/organic-orange-lipstick__47342.1593079691.png?c=1',
        product_link: 'https://odylique.com/organic-lipstick-apricot-sorbet.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: 'Apricot Sorbet provides a rich pop of orange to brighten every complexion. Great alone or over another colour to give a summery sheen.\n' +
          '\n' +
          'We hope you’ll love the creamy, nourishing texture of our lipsticks just as much as we do! \n' +
          'They are bursting with organic plant oils and butters including jojoba and Fairtrade shea to provide a moisturising vitamin-boost to your lips.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 67,
        brand: 'odylique',
        name: 'Organic Eye Liner - Grey',
        price: '24.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/181/463/organic-eye-liner-grey__70353.1593012885.png?c=1',
        product_link: 'https://odylique.com/odylique-eye-liner-grey.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: '100% natural - 64% organic mineral pencils\n' +
          '\n' +
          'Intensely rich ‘Slate’ mineral colour combined with organic jojoba, sunflower, Fairtrade shea butter and calendula for a rich, smooth texture that glides on effortlessly to define and nourish the delicate eye and lip areas.\n' +
          '\n' +
          'Our organic eyeliner works in harmony with our organic eyeshadows and lipsticks to dramatically define or subtly enhance the natural beauty of your eyes.',
        product_type: 'eyeliner',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 68,
        brand: 'odylique',
        name: 'Organic Eye Liner - Black',
        price: '24.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn11.bigcommerce.com/s-dfo8ssmots/images/stencil/1280x1280/products/180/464/organic-eyeliner__90011.1593012931.png?c=1',
        product_link: 'https://odylique.com/odylique-eye-pencil-black.html',
        website_link: 'https://odylique.com/fairtrade/',
        description: 'Intensely rich natural eyeliner colour combines with organic jojoba, sunflower, shea butter and calendula for a rich, smooth texture that glides on effortlessly to define and nourish the delicate eye and lip areas, without tugging or pulling.\n' +
          '\n' +
          'Whether you are aiming to go for an inky-black dramatic effect or more understated eye definition, this deeply pigmented eyeliner is perfect and works in harmony with our organic eye shadows to dramatically define or subtly enhance the natural beauty of your eyes.\n' +
          '\n' +
          'Our eye pencils are hypoallergenic and free from synthetic chemicals such as parabens. Gentle enough for sensitive eyes. ',
        product_type: 'eyeliner',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 69,
        brand: 'eco lips',
        name: 'Vegan Brazilian Lip Tint Blissful + Vegan Vanilla Sugar Lip Scrub',
        price: '6.49',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0268/8827/4105/products/Brazilian-Lip-Tint-Scrub-Combo-Pack-Blissful_2000x.png?v=1604516619',
        product_link: 'https://ecolips.com/collections/vegan-tint/products/vegan-brazilian-lip-tint-blissful-vegan-vanilla-sugar-lip-scrub',
        website_link: 'https://ecolips.com/',
        description: 'Luxurious with a creamy satin finish, this vegan Brazilian Lip Tint features ethically sourced Babaçu & Pracaxi Oils along with Cupuaçu Butter from Brazil to nourish, moisturize, and protect lips. Blissful is a soft dusty rose for a perfect barely-there flush of color on the lips. With a fruity, floral flavor of passionfruit, this Fair Trade Certified™, earth mineral tint provides pretty, matte coverage for everyday use. The vegan vanilla lip scrub provides exfoliation to prep your lips before applying the vegan tint. Gently rub on lips and wipe off lick off remaining sugar.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 70,
        brand: 'eco lips',
        name: 'Vegan Brazilian Lip Tint Blessed + Vegan Vanilla Sugar Lip Scrub',
        price: '6.49',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0268/8827/4105/products/Brazilian-Lip-Tint-Scrub-Combo-Pack-Blessed_2000x.png?v=1604516487',
        product_link: 'https://ecolips.com/collections/vegan-tint/products/vegan-brazilian-lip-tint-blessed-vegan-vanilla-sugar-lip-scrub',
        website_link: 'https://ecolips.com/',
        description: 'Luxurious with a creamy satin finish, this vegan Brazilian Lip Tint features ethically sourced Babaçu & Pracaxi Oils along with Cupuaçu Butter from Brazil to nourish, moisturize, and protect lips. Blessed offers a rouge pink color that’s soft, rosy, and styled for a natural, contemporary look. With a fruity, floral flavor of passionfruit, this Fair Trade Certified™, earth mineral tint provides pretty, matte coverage for everyday use. The vegan vanilla lip scrub provides exfoliation to prep your lips before applying the vegan tint. Gently rub on lips and wipe off or lick off remaining sugar!',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 71,
        brand: 'cocokind',
        name: 'mai-light rosé highlighter stick',
        price: '12.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0603/2741/products/skincare-mai-light-rose-highlighter-2_9d55a2b3-8ac9-444c-a38b-ea27cfa80e85_1024x.jpg?v=1600791783',
        product_link: 'https://www.cocokind.com/products/mai-light-1',
        website_link: 'https://www.cocokind.com/?sscid=61k5_uk69z&utm_campaign=1449860&utm_medium=affiliate&utm_source=314743',
        description: 'accentuate your favorite features with this vegan rose gold highlighter stick.',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 72,
        brand: 'cocokind',
        name: 'sunrei reishi gold highlighter',
        price: '12.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0603/2741/products/skincare-sunrei-reishi-gold-highlighter-4_1024x.jpg?v=1621621853',
        product_link: 'https://www.cocokind.com/products/sunrei-1',
        website_link: 'https://www.cocokind.com/?sscid=61k5_uk69z&utm_campaign=1449860&utm_medium=affiliate&utm_source=314743',
        description: 'accentuate your favorite features with this vegan rose gold highlighter stick.',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 73,
        brand: 'cocokind',
        name: 'macbeet tinted moisture stick',
        price: '12.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0603/2741/products/skincare-macabeet-tinted-moisture-stick-3_a64559e4-d17a-425e-9ab5-cb7e1e6031c9_1024x.jpg?v=1621537238',
        product_link: 'https://www.cocokind.com/collections/makeup/products/macabeet-tinted-moisture-stick?sscid=61k5_uka11&utm_source=314743&utm_medium=affiliate&utm_campaign=1449860',
        website_link: 'https://www.cocokind.com/?sscid=61k5_uk69z&utm_campaign=1449860&utm_medium=affiliate&utm_source=314743',
        description: 'give lips and cheeks a touch of natural-looking color and a burst of hydration.\n',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 1,
        organic: 1,
        vegan: 1,
        zero_waste: 0
      },
    {
        id: 74,
        brand: 'axiology',
        name: 'Axiology Lip to Lid Balmies',
        price: '14.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/1167/0230/products/Axiology_Balmie_Peach_5000x.jpg?v=1614700206',
        product_link: 'https://allnaturalcollection.com/collections/axiology-natural-lipstick/products/axiology-lip-to-lid-balmies?variant=39250251972682',
        website_link: 'https://allnaturalcollection.com/',
        description: 'Axiology Lip-to-Lid Balmies are versatile and easy to use makeup crayons that give eyes, cheeks and lips an instant wash of color. Balmies glide on smoothly, blend seamlessly and keep skin feeling smooth and hydrated.\n' +
          '\n' +
          'Don’t let the small size fool you. Axiology Balmies are the standard lipstick size minus the tube and cap. With only a little practice, these sustainable makeup sticks will replace your lipstick, eye shadow and blush (and the plastic waste that comes with them).',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 75,
        brand: 'axiology',
        name: 'Axiology Of the Earth Balmies Trio',
        price: '36.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/1167/0230/products/Axiology_Balmies_Of_The_Earth_1200x.jpg?v=1614791887',
        product_link: 'https://allnaturalcollection.com/collections/axiology-natural-lipstick/products/axiology-of-the-earth-balmies-trio',
        website_link: 'https://allnaturalcollection.com/',
        description: 'Axiology 3-in-1 balmies glide on smoothly for buildable color on eyes, cheeks, and lips. These innovative makeup crayons come in a peel-off wrapper and rest in a recyclable carrying case handmade from recycled trash by a women’s cooperative in Bali.\n' +
          '\n' +
          'The Of The Earth trio includes warm, earthy blush tones plus a shimmery gold. They blend seamlessly into skin to create shimmering accents or give skin a natural looking luminous glow.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 76,
        brand: 'axiology',
        name: '3 in 1 Balmies Trio - Cotton Candy Skies',
        price: '36.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/1167/0230/products/Axiology-Cotton-Candy-Skies-Lip-To-Lid-Trio_1200x.jpg?v=1614630016',
        product_link: 'https://allnaturalcollection.com/collections/axiology-natural-lipstick/products/axiology-cotton-candy-skies-balmies-set',
        website_link: 'https://allnaturalcollection.com/',
        description: 'Axiology Lip-to-Lid Balmies are versatile and easy to use makeup crayons that give eyes, cheeks and lips an instant wash of color. Cotton Candy Skies contains 2 soft rosy nudes plus a shimmery nude with a soft golden sheen. They build and blend effortlessly into skin to create shimmering accents or give skin a natural looking luminous glow. With clean ingredients and minimally packaged, balmies are the definition of simplicity and sustainability.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 77,
        brand: 'axiology',
        name: 'Axiology Malibu Magic Balmies Trio',
        price: '36.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/1167/0230/products/Axiology_Malibu_Magic_Balmies_1200x.jpg?v=1614793823',
        product_link: 'https://allnaturalcollection.com/collections/axiology-natural-lipstick/products/axiology-malibu-magic-balmies-trio',
        website_link: 'https://allnaturalcollection.com/',
        description: 'Axiology 3-in-1 balmies glide on smoothly for buildable color on eyes, cheeks, and lips. These innovative makeup crayons come in a peel-off wrapper and rest in a recyclable carrying case handmade from recycled trash by a women’s cooperative in Bali.\n' +
          '\n' +
          'The Malibu Magic trio includes peachy nudes for the perfect coral sun-kissed glow. ',
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 78,
        brand: 'besame cosmetics',
        name: 'Black Cake Mascara - 1920',
        price: '25.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0642/8495/products/dHj3ZMdSYDQO24nT1a6K1QZiqdkN2aUr-24_400x.jpg?v=1568683598',
        product_link: 'https://besamecosmetics.com/collections/eyes-1/products/black-cake-mascara',
        website_link: 'https://besamecosmetics.com/',
        description: 'Discover our best-selling Cake Mascara, inspired by a product from the 1920s.\n' +
          '\n' +
          "Especially made for sensitive eyes, Bésame’s Cake Mascara is the cleanest form of mascara on the market. This water-activated product doesn't harbor or grow bacteria once it dries back down to a solid cake. Made from a natural wax that bends with your skin and lashes so it doesn’t flake, peel, or clump.\n" +
          '\n' +
          'Cake Mascara is truly a low-waste product. It comes packaged in a recyclable tin that can also be reused once you’re ready for a refill.\n' +
          'The Malibu Magic trio includes peachy nudes for the perfect coral sun-kissed glow. ',
        product_type: 'mascara',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 79,
        brand: 'besame cosmetics',
        name: 'Poppy Cream Rouge',
        price: '20.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0642/8495/products/poppy2020_400x_c28d443b-d7da-4cd3-8431-092952edefbc_400x.png?v=1599597918',
        product_link: 'https://besamecosmetics.com/collections/cream-rouge/products/poppy-cream-rouge',
        website_link: 'https://besamecosmetics.com/',
        description: 'Our concentrated cream rouge gives lips and cheeks a natural, weightless flush and blends beautifully onto the skin with a simple swipe of the finger.\n' +
          '\n' +
          'Suitable for all skin tones, our Poppy Cream Rouge is a warm-toned pink shade with a hint of coral that is highly pigmented for buildable color that stays on all day.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 80,
        brand: 'besame cosmetics',
        name: 'Crimson Cream Rouge - 1938',
        price: '20.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0642/8495/products/Crimson2020_400x.jpg?v=1578265437',
        product_link: 'https://besamecosmetics.com/collections/cream-rouge/products/crimson-cream',
        website_link: 'https://besamecosmetics.com/',
        description: 'Our concentrated cream rouge gives lips and cheeks a natural, weightless flush and blends beautifully onto the skin with a simple swipe of the finger. Suitable for all skin tones, our Crimson Cream Rouge is a natural rosy red shade shade that is highly pigmented for buildable color that stays on all day.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 81,
        brand: 'izzy',
        name: 'Zero Waste Mascara',
        price: '39.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0048/2027/1174/products/042021_IZZY_PDP_IMAGES_2048x2934_02_2000x.progressive.jpg?v=1618951515',
        product_link: 'https://yourizzy.com/products/zero-waste-mascara',
        website_link: 'https://yourizzy.com/',
        description: 'Let your lashes get loud with a lustrous coat of dramatic volume that you can feel good about. Buildable, clean, vegan-friendly and zero waste, our super volumizing mascara adds fullness, length and lift for big, fanned-out lashes that practically hit your browbone. Our proprietary High-Fidelity Wave Brush features a dip in the middle for mess-free application that builds all lash types upward and outward without caking or clumping.',
        product_type: 'mascara',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 0,
        zero_waste: 1
      },
    {
        id: 82,
        brand: 'tata harper',
        name: 'Flashy',
        price: '42.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://www.tataharperskincare.com/media/catalog/product/cache/57be28060250e32cca64206b2a977340/f/l/flashy_withcap-pdp-1000.jpg',
        product_link: 'https://www.tataharperskincare.com/flashy-cream-highlighter',
        website_link: 'https://www.tataharperskincare.com',
        description: 'Our super-creamy highlighter washes cheeks, lips, and lids in a soft golden glow in a flattering, radiant finish. This ultra-blendable, weightless formula melts effortlessly onto skin to give you a luminous definition while helping defend against environmental aggressors.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 83,
        brand: 'tata harper',
        name: 'Peachy',
        price: '42.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://www.tataharperskincare.com/media/catalog/product/cache/57be28060250e32cca64206b2a977340/p/e/peachy_withcap-pdp-1000.jpg',
        product_link: 'https://www.tataharperskincare.com/peachy-cream-blush',
        website_link: 'https://www.tataharperskincare.com',
        description: 'Our weightless, sheer blush offers your cheeks, lips, and lids a natural wash of golden peach with a satin, shimmering finish. This ultra-creamy formula melts onto skin for the perfect touch of flush while helping defend against environmental aggressors.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 84,
        brand: 'tata harper',
        name: 'Spicy',
        price: '42.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://www.tataharperskincare.com/media/catalog/product/cache/57be28060250e32cca64206b2a977340/s/p/spicy_withcap-pdp-1000.jpg',
        product_link: 'https://www.tataharperskincare.com/spicy-cream-blush',
        website_link: 'https://www.tataharperskincare.com',
        description: 'Our weightless, sheer blush offers your cheeks, lips, and lids a natural pop of terracotta pink with a satin finish. This ultra-creamy formula melts onto skin for the perfect touch of flush while helping defend against environmental aggressors.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 85,
        brand: 'tata harper',
        name: 'Be Adored',
        price: '32.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://www.tataharperskincare.com/media/catalog/product/cache/57be28060250e32cca64206b2a977340/p/d/pdp_be_adored_open_digital-1000-r1-0806.jpg',
        product_link: 'https://www.tataharperskincare.com/be-adored',
        website_link: 'https://www.tataharperskincare.com',
        description: 'A raspberry tinted hydrating & volumizing lip treatment that leaves lips looking fuller and feeling softer.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 1,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 86,
        brand: 'meow meow tweet',
        name: 'Vegan Lip Balm',
        price: '14.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/1797/9639/products/2020_Ecomm_MeowMeowTweet_LipBalm_All_1_1080x.jpg?v=1583193201',
        product_link: 'https://packagefreeshop.com/collections/cosmetics/products/vegan-lip-balm',
        website_link: 'https://packagefreeshop.com',
        description: 'Chap is WACK. Prevent chapped lips and keep your smile soft with this vegan lip balm!',
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 87,
        brand: 'kjaer weis',
        name: 'The Cheek Collective',
        price: '68.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/2426/9013/products/CheekCollective-LightFilled_Dotcom.jpg?v=1619807567',
        product_link: 'https://kjaerweis.com/products/the-cheek-collective-blossoming',
        website_link: 'https://kjaerweis.com',
        description: 'Sun-kissed skin essentials: Certified Organic cream blush, highlighter, and bronzer for a radiant summertime flush of color. ',
        product_type: 'blush',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 1
      },
    {
        id: 88,
        brand: 'kjaer weis',
        name: 'Cream Eye Shadow',
        price: '24.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/2426/9013/products/Midsummer-FourCreamEyeShadow-3_Credo.jpg?v=1621428888',
        product_link: 'https://kjaerweis.com/products/cream-eye-shadow-red-edition-ember',
        website_link: 'https://kjaerweis.com',
        description: 'Creamy, long-lasting color for lids that builds from sheer to intense.',
        product_type: 'eyeshadow',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 1
      },
    {
        id: 89,
        brand: 'kjaer weis',
        name: 'Lip Gloss',
        price: '22.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/2426/9013/products/LipGloss-Iconic-Red-Hot-Dotcom.jpg?v=1620410669',
        product_link: 'https://kjaerweis.com/products/lip-gloss-iconic-edition-red-hot',
        website_link: 'https://kjaerweis.com',
        description: 'Cushiony, softly tinted gloss packed with conditioning oils\n',
        product_type: 'lipstick',
        cruelty_free: 0,
        fair_trade: 0,
        organic: 1,
        vegan: 0,
        zero_waste: 0
      },
    {
        id: 90,
        brand: 'aleph beauty',
        name: 'Concealer / Foundation 1.0',
        price: '41.91',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-concealer-foundation-1-0_2000x.jpg?v=1569481034',
        product_link: 'https://alephbeauty.com/collections/concealer-foundation/products/concealer-foundation-1-0',
        website_link: 'https://alephbeauty.com',
        description: 'Aleph Concealer/Foundation is a multi-use, premium formula that self-adjusts to your skin tone.',
        product_type: 'foundation',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 91,
        brand: 'aleph beauty',
        name: 'Concealer / Foundation 2.0',
        price: '41.91',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-concealer-foundation-2-0_2000x.jpg?v=1569481038',
        product_link: 'https://alephbeauty.com/collections/concealer-foundation/products/concealer-foundation-2-0',
        website_link: 'https://alephbeauty.com',
        description: 'Aleph Concealer/Foundation is a multi-use, premium formula that self-adjusts to your skin tone.',
        product_type: 'foundation',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 92,
        brand: 'aleph beauty',
        name: 'Concealer / Foundation 3.0',
        price: '41.91',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-concealer-foundation-3-0_23042979-0eae-4cea-a366-bb41efa0e809_5000x.jpg?v=1569481039',
        product_link: 'https://alephbeauty.com/collections/concealer-foundation/products/concealer-foundation-3-0',
        website_link: 'https://alephbeauty.com',
        description: 'Aleph Concealer/Foundation is a multi-use, premium formula that self-adjusts to your skin tone.',
        product_type: 'foundation',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 93,
        brand: 'aleph beauty',
        name: 'Concealer / Foundation 5.0',
        price: '41.91',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/3ce4c1be-cf6b-46f8-84bd-b8e2a030d81b_2000x.jpg?v=1572905978',
        product_link: 'https://alephbeauty.com/collections/concealer-foundation/products/concealer-foundation-5-0',
        website_link: 'https://alephbeauty.com',
        description: 'Aleph Concealer/Foundation is a multi-use, premium formula that self-adjusts to your skin tone.',
        product_type: 'foundation',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 94,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Sangha',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-sangha_2000x.jpg?v=1606172142',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-sangha',
        website_link: 'https://alephbeauty.com',
        description: 'Sangha. A signature red for a striking cheek and lip look or instant confidence boost.\n' +
          '\n',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 95,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Reve',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-reve_2719c83c-bda9-4f85-b703-0448f232b6af_2000x.jpg?v=1621500984',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-reve',
        website_link: 'https://alephbeauty.com',
        description: 'Rêve. Exquisitely inspired by the ethereal bluish pink hue of a child’s flushed cheeks. Rêve can be worn as a delicate sheer tint on the lips and cheeks, and as a captivating pretty pink-but-not-too-pink lipstick.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 96,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Grounded',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-grounded_2000x.jpg?v=1569481052',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-grounded',
        website_link: 'https://alephbeauty.com',
        description: 'Grounded is the nude you have silently longed for. This exquisite neutral is designed to be the perfect everyday lip and cheek colour. Wear blended out on the cheeks, patted over the eyelids and smudged onto the lips for a stunning monochromatic look. This colour is 100% natural and dye free.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 97,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Terra',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-terra_2000x.jpg?v=1573070964',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-terra',
        website_link: 'https://alephbeauty.com',
        description: 'A deep rich chocolate brown. This uber versatile colour suited to all skin tones from fair to dark. Can be used on the lips as a deep intense chocolate or a sheer wash of soft terracotta. Use to contour the face, eyes, jawbone and neck. Apply as a cream bronzer. Use in conjunction with Concealer/Foundation 5.0 to custom create a deeper shade.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 98,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Ascend',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/2163f90f-68be-4e04-8893-8889dcb7220d_2000x.jpg?v=1573596280',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-ascend',
        website_link: 'https://alephbeauty.com',
        description: 'Ascend. Inspired by sunrise, this pure coral complements every skin tone, from the palest skin to a sun-kissed complexion. Sheer out on the cheeks for a summery vibe, tint the lips to make blue eyes pop, or apply with a lip brush for a stunning coral lip. For delicate peach use a light application, or intensely layer for show-stopping electric coral.',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 99,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Crush',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-crush-jar_2000x.jpg?v=1617865049',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-crush',
        website_link: 'https://alephbeauty.com',
        description: 'Crush emulates the perfect, luminous natural flush. A blood colour with both warm and cool undertones, this has been carefully created to suit every skin tone. Crush elevates and enhances every eye colour. ',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 100,
        brand: 'aleph beauty',
        name: 'Cheek / Lip Tint: Pixie',
        price: '38.42',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-cheek-lip-tint-pixie-limited-ed_2000x.jpg?v=1569523174',
        product_link: 'https://alephbeauty.com/collections/cheek-lip-tint/products/cheek-lip-tint-pixie',
        website_link: 'https://alephbeauty.com',
        description: 'Pixie. Limited Edition. A warm rose, carefully crafted to resemble the sweetest youthful rosebud lip. Pixie can be worn as a whisper of colour on the cheeks and lips or a rich creamy nourishing lipstick. ',
        product_type: 'lipstick',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 101,
        brand: 'aleph beauty',
        name: 'Radiance: Star',
        price: '34.93',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-radiance-star_2000x.jpg?v=1606171507',
        product_link: 'https://alephbeauty.com/collections/radiance/products/radiance-star',
        website_link: 'https://alephbeauty.com',
        description: 'Star. A pick-me-up orchid pink that adds a soft and subtle tint for a celestial glow. The perfect alchemy to transform your makeup.\n' +
          '\n' +
          'Formulated to add a third dimension to your makeup, this cream glow makes a stunning eye tint, foundation luminiser and adds pearlescence to any lip colour.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 102,
        brand: 'aleph beauty',
        name: 'Radiance: Moon',
        price: '34.93',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-moon-radiance_2000x.jpg?v=1569523174',
        product_link: 'https://alephbeauty.com/collections/radiance/products/radiance-moon',
        website_link: 'https://alephbeauty.com',
        description: 'MOON. Highlight your best features with this beautiful champagne coloured glow. Formulated for maximum versatility, this densely pigmented cream highlight makes a stunning eyeshadow, foundation luminizer and adds pearlescence to any lipstick.\n' +
          '\n' +
          'The perfect Alchemy to transform your makeup.\n' +
          '\n' +
          'Radiance imparts an ethereal glow when mixed with your Concealer/Foundation prior to application. Glossy, glowing eyelids when used as an eyeshadow. A transformative iridescence when applied to the lips or over a lip colour and the perfect highlighter when applied to the high points of the face.',
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 103,
        brand: 'aleph beauty',
        name: 'Radiance: Sun',
        price: '34.93',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0110/8587/3210/products/aleph-sun-radiance_2000x.jpg?v=1569523175',
        product_link: 'https://alephbeauty.com/collections/radiance/products/radiance-sun',
        website_link: 'https://alephbeauty.com',
        description: "Sun. Wear the perfect sun kissed glow your way. As with all Aleph products, Radiance is made to be versatile. This makes a great blush, eyeshadow, lip colour and bronzer. Wear on it's own or layer to transform other colours. ",
        product_type: 'blush',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 1,
        zero_waste: 1
      },
    {
        id: 104,
        brand: 'principle beauty',
        name: 'The Desert Nomad Palette',
        price: '48.00',
        price_sign: '$',
        currency: 'USD',
        image_link: 'https://cdn.shopify.com/s/files/1/0421/6127/5048/products/PaletteonCurledPalmSquare.jpg?v=1614621131',
        product_link: 'https://principlebeauty.com/products/principle-beauty-desert-nomad-palette',
        website_link: 'https://principlebeauty.com',
        description: "Inspired by our travels through the American Southwest, our signature eye palette features our high-pigment pressed eye color crafted from ethically sourced minerals. We've also added organic shea butter, jojoba oil and coconut oil for a blendable, velvety finish.",
        product_type: 'eyeshadow',
        cruelty_free: 1,
        fair_trade: 0,
        organic: 0,
        vegan: 0,
        zero_waste: 1
      }
  ]
  module.exports = productsData;